import { has, pipe, set } from 'lodash/fp';
import { matchPath } from 'react-router';
import { workspacesFetch } from 'actions/workspacesFetch';

function workspaceMiddleware(opts) {
  // Production passes `getLocation` (a getter so the middleware reads the
  // current router location, not a value captured at boot). Tests/stories
  // pass a `history` object directly, where `.location` updates live.
  const getLocation = opts.getLocation ?? (() => opts.location);
  return ({ getState }) =>
    (next) =>
    (action) => {
      const state = getState();
      const pathname = getLocation()?.pathname;
      if (pathname == null) {
        next(action);
        return;
      }
      const match =
        matchPath({ path: '/workspaces/:workspaceId/*' }, pathname) ??
        matchPath({ path: '/public/:workspaceId/*' }, pathname) ??
        matchPath({ path: '/embed/:workspaceId/*' }, pathname);
      const workspaceId = match?.params?.workspaceId;
      const isPublic =
        pathname.startsWith('/public') || pathname.startsWith('/embed');

      if (workspaceId == null) {
        next(action);
        return;
      }

      if (
        action.type !== workspacesFetch.pending.type &&
        !has(['meta', 'arg', 'workspaceId'], action) &&
        (has(workspaceId, state.workspaces) ||
          has(workspaceId, state.publicWorkspaces))
      ) {
        next(
          pipe(
            set(['meta', 'arg', 'workspaceId'], workspaceId),
            set(['meta', 'arg', 'isPublic'], isPublic),
          )(action),
        );
      } else {
        next(action);
      }
    };
}

export default workspaceMiddleware;
